<template>
  <md-card class="md-card-profile">
    <md-card-content>
      <h4 class="card-title">Pedidos proximos dias</h4>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-85">
          <md-datepicker v-model="fecha_buscar">
            <label>Dia</label>
          </md-datepicker>
        </div>
        <md-button class="md-icon-button md-success" v-on:click="Buscar()">
          <md-icon>remove_red_eye</md-icon>
        </md-button>
      </div>
      <div class="alert alert-success" v-for="fecha in fechas" :key="fecha">
        <span>
          <md-icon>calendar_today</md-icon>
          {{ fecha.fecha | moment("Y-MM-DD") }} - {{ fecha.pedidos }}
        </span>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import axios from "axios";
import Global from "../../Global";
export default {
  name: "user-card",
  data() {
    return {
      url: Global.url,
      fechas: null,
      fecha_buscar: null
    };
  },
  mounted() {
    axios
      .get(this.url + "pedido/proximas-fechas", {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(res => {
        this.fechas = res.data;
      })
      .catch(error => {
        alert(error);
      });
  },
  methods: {
    Buscar() {
      var buscar = this.$moment(this.fecha_buscar).format("Y-MM-DD");
      axios
        .get(this.url + "pedido/proximas-fechas/" + buscar, {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(res => {
          this.fechas = res.data;
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
<style></style>
